module.exports = __webpack_public_path__ + "static/media/deliveryVan_orange.9de17143.svg";